import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Button,
  Spinner,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// Form Mask
import InputMask from "react-input-mask";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import { getCompany, editCompany, resetCompany } from "../../store/company/actions";

const EditCompany = ({ t }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { data } = useSelector((state) => state.Login);
  const {
    successCompany,
    errorCompany,
    loadingCompany,
    dataCompany,
  } = useSelector((state) => state.Company);

  const [labelCpfCnpj, setLabelCpfCnpj] = useState("CNPJ");

  const [name, setName] = useState("");
  const [domain, setDomain] = useState("");
  const [pfpj, setPjPf] = useState("");
  const [document, setDocument] = useState("");
  const [email, setEmail] = useState("");

  const [clientCEP, setclientCEP] = useState("");
  const [clientAddress, setclientAddress] = useState("");
  const [clientNeighborhood, setclientNeighborhood] = useState("");
  const [clientCity, setclientCity] = useState("");
  const [clientState, setclientState] = useState("");
  const [clientResponsible, setclientResponsible] = useState("");
  const [clientActivities, setclientActivities] = useState("");
  const [clientClientNumber, setclientClientNumber] = useState("");
  const [clientClientResponsibleNumber, setclientResponsibleNumber] = useState(
    ""
  );
  const [clientObservation, setclientObservation] = useState("");

  const handleEditCompany = (event, values) => {
    const clientInfo = {
      cep: values.cep,
      address: values.address,
      neighborhood: values.neighborhood,
      city: values.city,
      state: values.state,
      responsible: values.responsible,
      activities: values.activities,
      clientnumber: values.clientnumber,
      responsiblenumber: values.responsiblenumber,
      observation: values.observation,
    };
    const companyValues = {
      domain: values.domain,
      email: values.email,
      client_info: clientInfo,
    };
    dispatch(editCompany(companyValues));
  };

  useEffect(() => {
    if (data && data.company) {
      dispatch(resetCompany());
      dispatch(getCompany(data.company.id));
    }
  }, [dispatch, data]);

  useEffect(() => {
    if (dataCompany && dataCompany.data && dataCompany.data.client) {
      setName(dataCompany.data.client[0].name);
      setDomain(dataCompany.data.client[0].domain);
      if (dataCompany.data.client[0].pf === "1") {
        setPjPf("PF");
        setLabelCpfCnpj("CPF");
      }
      if (dataCompany.data.client[0].pj === "1") {
        setPjPf("PJ");
        setLabelCpfCnpj("CNPJ");
      }
      setDocument(dataCompany.data.client[0].document);
      setEmail(dataCompany.data.client[0].email);

      if (dataCompany.data.client[0].client_info) {
        setclientCEP(dataCompany.data.client[0].client_info.cep);
        setclientAddress(dataCompany.data.client[0].client_info.address);
        setclientNeighborhood(
          dataCompany.data.client[0].client_info.neighborhood
        );
        setclientCity(dataCompany.data.client[0].client_info.city);
        setclientState(dataCompany.data.client[0].client_info.state);
        setclientActivities(dataCompany.data.client[0].client_info.activities);
        setclientClientNumber(
          dataCompany.data.client[0].client_info.clientnumber
        );
        setclientResponsible(
          dataCompany.data.client[0].client_info.responsible
        );
        setclientResponsibleNumber(
          dataCompany.data.client[0].client_info.responsiblenumber
        );
        setclientObservation(
          dataCompany.data.client[0].client_info.observation
        );
      }
    }
  }, [dispatch, dataCompany]);

  let showToast = function (type, msg) {
    toastr[type](msg);
  };

  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successCompany && history.push("/dashboard"),
  };

  useEffect(() => {
    if (successCompany && dataCompany) {
      showToast(
        "success",
        (dataCompany && dataCompany.message) === "Company created"
          ? t("Company created")
          : (dataCompany && dataCompany.message) === "Client updated" &&
              t("Company updated")
      );
      dispatch(resetCompany());
    }
  }, [dispatch, dataCompany, successCompany, t]);

  useEffect(() => {
    if (errorCompany) {
      showToast(
        "error",
        errorCompany[0].value === "email must be a valid email"
          ? t("email must be a valid email")
          : errorCompany === "Your session has expired"
          ? t("Your session has expired")
          : errorCompany ===
            "Sorry! the page you are looking for could not be found"
          ? t("Sorry! the page you are looking for could not be found")
          : errorCompany ===
              "Sorry! something went wrong, please contact our support team" &&
            t("Sorry! something went wrong, please contact our support team")
      );
      dispatch(resetCompany());
    }
  }, [dispatch, errorCompany, t]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/dashboard"
            path="/company"
            title={t("Dashboard")}
            breadcrumbItem={t("Edit Company")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  {dataCompany && (
                    <AvForm onValidSubmit={handleEditCompany}>
                      <Row>
                        <Col sm="6">
                          <FormGroup>
                            <AvField
                              style={{ cursor: "no-drop" }}
                              disabled
                              value={pfpj}
                              id="pfpj"
                              name="pfpj"
                              className="form-control"
                              type="text"
                              label=" PF/PJ"
                            ></AvField>
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              style={{ cursor: "no-drop" }}
                              disabled
                              value={name}
                              label={t("Company name")}
                              id="companyname"
                              name="companyname"
                              type="text"
                              className="form-control"
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setDomain(e.target.value);
                              }}
                              value={domain}
                              label={t("Site") + " *"}
                              id="site"
                              name="domain"
                              type="text"
                              className="form-control"
                              placeholder={t("www.mycompany.com")}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                                maxLength: {
                                  value: 50,
                                  errorMessage: t("Invalid field"),
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setclientAddress(e.target.value);
                              }}
                              value={clientAddress ?? ""}
                              label={t("Address")}
                              id="address"
                              name="address"
                              type="text"
                              className="form-control"
                              placeholder={t(
                                "Enter the street name and number"
                              )}
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setclientCity(e.target.value);
                              }}
                              value={clientCity ?? ""}
                              label={t("City")}
                              id="city"
                              name="city"
                              type="text"
                              className="form-control"
                              placeholder={t("City")}
                              validate={{
                                maxLength: {
                                  value: 50,
                                  errorMessage: t("Invalid field"),
                                },
                                pattern: {
                                  value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                  errorMessage: t(
                                    "Your City must be composed only with letter, numbers and space"
                                  ),
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setclientResponsible(e.target.value);
                              }}
                              value={clientResponsible ?? ""}
                              label={t("Responsible")}
                              id="responsible"
                              name="responsible"
                              type="text"
                              className="form-control"
                              placeholder={t(
                                "Enter the name of the Responsible"
                              )}
                              validate={{
                                maxLength: {
                                  value: 50,
                                  errorMessage: t("Invalid field"),
                                },
                                pattern: {
                                  value: "/^[A-Za-z áàâãéèêíïóôõöúç]*$/i", // only letters and space
                                  errorMessage: t(
                                    "Responsible name must be composed only with letter and space"
                                  ),
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setclientClientNumber(e.target.value);
                              }}
                              value={clientClientNumber}
                              label={t("Company number")}
                              tag={InputMask}
                              mask={"(99)99999-9999"}
                              maskChar={null}
                              id="clientnumber"
                              name="clientnumber"
                              type="text"
                              className="form-control"
                              placeholder="(__)_____-____"
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setclientObservation(e.target.value);
                              }}
                              value={clientObservation ?? ""}
                              label={t("Observation")}
                              id="observation"
                              name="observation"
                              type="text"
                              className="form-control"
                              placeholder={t("Enter notes")}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                          <FormGroup>
                            <AvField
                              style={{ cursor: "no-drop" }}
                              disabled
                              label={labelCpfCnpj}
                              value={document}
                              mask={
                                labelCpfCnpj === "CPF"
                                  ? "999.999.999-99"
                                  : "99.999.999/9999-99"
                              }
                              id="CPFCNPJ"
                              name="CPFCNPJ"
                              type="text"
                              className="form-control"
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setEmail(e.target.value);
                              }}
                              value={email}
                              label={t("Email") + " *"}
                              id="email"
                              name="email"
                              type="email"
                              className="form-control"
                              placeholder={t("example@example.com")}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                                email: {
                                  value: true,
                                  errorMessage: t("Incorrect email"),
                                },
                                maxLength: {
                                  value: 50,
                                  errorMessage: t("Invalid field"),
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setclientCEP(e.target.value);
                              }}
                              value={clientCEP}
                              label={t("Postal code") + " *"}
                              tag={InputMask}
                              mask="99999-999"
                              maskChar={null}
                              id="cep"
                              name="cep"
                              type="text"
                              className="form-control"
                              placeholder="_____-___"
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                                minLength: {
                                  value: 9,
                                  errorMessage: t("Required Field"),
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setclientNeighborhood(e.target.value);
                              }}
                              value={clientNeighborhood ?? ""}
                              label={t("Neighborhood")}
                              id="neighborhood"
                              name="neighborhood"
                              type="text"
                              className="form-control"
                              placeholder={t(
                                "Enter the neighborhood in which the company is located"
                              )}
                              validate={{
                                maxLength: {
                                  value: 50,
                                  errorMessage: t("Invalid field"),
                                },
                                pattern: {
                                  value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                  errorMessage: t(
                                    "Your Neighborhood must be composed only with letter, numbers and space"
                                  ),
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setclientState(e.target.value);
                              }}
                              value={clientState}
                              name="state"
                              className="form-control"
                              type="select"
                              label={t("State")}
                            >
                              <option value="">{t("Select")}</option>
                              <option value="AC">Acre</option>
                              <option value="AL">Alagoas</option>
                              <option value="AP">Amapá</option>
                              <option value="AM">Amazonas</option>
                              <option value="BA">Bahia</option>
                              <option value="CE">Ceará</option>
                              <option value="DF">Distrito Federal</option>
                              <option value="ES">Espirito Santo</option>
                              <option value="GO">Goiás</option>
                              <option value="MA">Maranhão</option>
                              <option value="MS">Mato Grosso do Sul</option>
                              <option value="MT">Mato Grosso</option>
                              <option value="MG">Minas Gerais</option>
                              <option value="PA">Pará</option>
                              <option value="PB">Paraíba</option>
                              <option value="PR">Paraná</option>
                              <option value="PE">Pernambuco</option>
                              <option value="PI">Piauí</option>
                              <option value="RJ">Rio de Janeiro</option>
                              <option value="RN">Rio Grande do Norte</option>
                              <option value="RS">Rio Grande do Sul</option>
                              <option value="RO">Rondônia</option>
                              <option value="RR">Roraima</option>
                              <option value="SC">Santa Catarina</option>
                              <option value="SP">São Paulo</option>
                              <option value="SE">Sergipe</option>
                              <option value="TO">Tocantins</option>
                            </AvField>
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setclientActivities(e.target.value);
                              }}
                              value={clientActivities}
                              className="form-control"
                              name="activities"
                              type="select"
                              label={t("Activity")}
                            >
                              <option value="">{t("Select")}</option>
                              <option value="Academia-de-Esportes">
                                Academia de Esportes
                              </option>
                              <option value="Artes-Marciais">
                                Artes Marciais
                              </option>
                              <option value="Açúcar-Álcool">
                                Açúcar e Álcool
                              </option>
                              <option value="Administração-Participação">
                                Administração e Participação
                              </option>
                              <option value="Agências-de-Turismo-Viagem">
                                Agências de Turismo / Viagem
                              </option>
                              <option value="Agricultura-Pecuária-Silvicultura">
                                Agricultura / Pecuária / Silvicultura
                              </option>
                              <option value="Alimentos">Alimentos</option>
                              <option value="Arquitetura-Paisagismo-Urbanismo">
                                Arquitetura / Paisagismo / Urbanismo
                              </option>
                              <option value="Assessoria-de-Imprensa">
                                DAssessoria de Imprensa
                              </option>
                              <option value="Automação">Automação</option>
                              <option value="Automotivo">Automotivo</option>
                              <option value="Bancário-Financeiro">
                                Bancário / Financeiro
                              </option>
                              <option value="Bebidas">Bebidas</option>
                              <option value="Bens de Capital">
                                Bens de Capital
                              </option>
                              <option value="Bens de Consumo (Outros)">
                                Bens de Consumo (Outros)
                              </option>
                              <option value="Borracha">Borracha</option>
                              <option value="Café">Café</option>
                              <option value="Calçados">Calçados</option>
                              <option value="Comércio-Atacadista">
                                Comércio Atacadista
                              </option>
                              <option value="Comércio-Varejista">
                                Comércio Varejista
                              </option>
                              <option value="Comunicação">Comunicação</option>
                              <option value="Concessionárias-Auto Peças">
                                Concessionárias / Auto Peças
                              </option>
                              <option value="Construção-Civil">
                                Construção Civil
                              </option>
                              <option value="Consultoria-Geral">
                                Consultoria Geral
                              </option>
                              <option value="Contabilidade-Auditoria">
                                Contabilidade / Auditoria
                              </option>
                              <option value="Corretagem-Imóveis-">
                                Corretagem (Imóveis)
                              </option>
                              <option value="Corretagem-Seguros">
                                Corretagem (Seguros)
                              </option>
                              <option value="Corretagem-de-Títulos-e-Valores-Imobiliários">
                                Corretagem de Títulos e Valores Imobiliários
                              </option>
                              <option value="Cosméticos">Cosméticos</option>
                              <option value="Diversão-Entretenimento">
                                Diversão / Entretenimento
                              </option>
                              <option value="Educação-Idiomas">
                                Educação / Idiomas
                              </option>
                              <option value="Eletrônica-Eletroeletrônica-Eletrodomésticos">
                                Eletrônica / Eletroeletrônica / Eletrodomésticos
                              </option>
                              <option value="Energia-Eletricidade">
                                Energia / Eletricidade
                              </option>
                              <option value="Engenharia">Engenharia</option>
                              <option value="Equipamentos-industriais">
                                Equipamentos-industriais
                              </option>
                              <option value="Equipamentos-médicos-precisão">
                                Equipamentos médicos / precisão
                              </option>
                              <option value="Estética-Academias">
                                Estética / Academias
                              </option>
                              <option value="Eventos">Eventos</option>
                              <option value="Farmacêutica-Veterinária">
                                Farmacêutica/ Veterinária
                              </option>
                              <option value="Financeiras">Financeiras</option>
                              <option value="Gráfica-Editoras">
                                Gráfica / Editoras
                              </option>
                              <option value="Importação-Exportação">
                                Importação / Exportação
                              </option>
                              <option value="Incorporadora">
                                Incorporadora
                              </option>
                              <option value="Indústrias">Indústrias</option>
                              <option value="Informática">Informática</option>
                              <option value="Internet-Sites">
                                Internet / Sites
                              </option>
                              <option value="Jornais">Jornais</option>
                              <option value="Jurídica">Jurídica</option>
                              <option value="Logística-Armazéns">
                                Logística / Armazéns
                              </option>
                              <option value="Madeiras">Madeiras</option>
                              <option value="Materiais-de-Construção">
                                Materiais de Construção
                              </option>
                              <option value="Material-de-Escritório">
                                Material de Escritório
                              </option>
                              <option value="Mecânica-Manutenção">
                                Mecânica / Manutenção
                              </option>
                              <option value="Metalúrgica-Siderúrgica">
                                Metalúrgica / Siderúrgica
                              </option>
                              <option value="Mineração">Mineração</option>
                              <option value="Móveis-e-Artefatos-de-decoração">
                                Móveis e Artefatos de decoração
                              </option>
                              <option value="Órgãos-públicos">
                                Órgãos públicos
                              </option>
                              <option value="Outros">Outros</option>
                              <option value="Papel-e-Derivados">
                                Papel-e-Derivados
                              </option>
                              <option value="Petroquímico-Petróleo">
                                Petroquímico / Petróleo
                              </option>
                              <option value="Plásticos">Plásticos</option>
                              <option value="Prestadora-de-Serviços">
                                Prestadora de Serviços
                              </option>
                              <option value="Publicidade-Propaganda">
                                Publicidade / Propaganda
                              </option>
                              <option value="Recursos-Humanos">
                                Recursos Humanos
                              </option>
                              <option value="Relações-Públicas">
                                Relações Públicas
                              </option>
                              <option value="Representação-Comercial">
                                Representação Comercial
                              </option>
                              <option value="Restaurante-Industrial-Fast FoodJ">
                                Restaurante / Industrial / Fast Food
                              </option>
                              <option value="Saúde">Saúde</option>
                              <option value="Segurança-Patrimonial">
                                Segurança Patrimonial
                              </option>
                              <option value="Seguros-PrevidênciaPrivada">
                                Seguros / Previdência Privada
                              </option>
                              <option value="Sindicatos-Associações-ONGs">
                                Sindicatos / Associações / ONGs
                              </option>
                              <option value="Supermercado-Hipermercado">
                                Supermercado / Hipermercado
                              </option>
                              <option value="Telecomunicações">
                                Telecomunicações
                              </option>
                              <option value="Telemarketing-Call-Center">
                                Telemarketing / Call Center
                              </option>
                              <option value="Têxtil-Couro">
                                Têxtil / Couro
                              </option>
                              <option value="Transportes">Transportes</option>
                              <option value="Turismo-Hotelaria">
                                Turismo / Hotelaria
                              </option>
                            </AvField>
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              onChange={(e) => {
                                setclientResponsibleNumber(e.target.value);
                              }}
                              value={clientClientResponsibleNumber}
                              label={t("Responsible number")}
                              tag={InputMask}
                              mask={"(99)99999-9999"}
                              maskChar={null}
                              id="responsiblenumber"
                              name="responsiblenumber"
                              type="text"
                              className="form-control"
                              placeholder="(__)_____-____"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {loadingCompany ? (
                        <Button
                          disabled={true}
                          style={{
                            width: "100px",
                            cursor: "no-drop",
                          }}
                          color="primary"
                          className="mr-1 waves-effect waves-light"
                        >
                          <Spinner
                            size="sm"
                            animation="border"
                            style={{
                              height: "19px",
                              width: "19px",
                            }}
                          />
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          className="mr-1 waves-effect waves-light"
                          type="submit"
                        >
                          {t("Confirm")}
                        </Button>
                      )}
                      <Link to="/dashboard">
                        <Button
                          type="button"
                          color="secondary"
                          className="waves-effect btn-dark"
                        >
                          {t("Cancel")}
                        </Button>
                      </Link>
                    </AvForm>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(EditCompany);
